import React from "react";

type MainContentProps = {
  title?: string;
  style?: React.CSSProperties;
  children: any;
};

type HeadingProps = {
  text: string;
  style?: React.CSSProperties;
};

type ContentProps = {
  style?: React.CSSProperties;
  children?: any;
};

const ToolsContent = ({
  title = "",
  style = {},
  children = null,
}: MainContentProps) => {
  return (
    <div style={{ margin: 2.5, ...style }}>
      {title !== "" && <Heading text={title} style={{ margin: "auto" }} />}
      {children}
    </div>
  );
};

const Heading = ({ text, style = {} }: HeadingProps) => {
  return (
    <h3
      style={{
        fontSize: "20px",
        lineHeight: "23px",
        color: "#F89723",
        textAlign: "left",
        fontWeight: "bold",
        textTransform: "capitalize",
        paddingLeft: 7,
        ...style,
      }}
    >
      {text}
    </h3>
  );
};

const Body = ({ style = {}, children = null }: ContentProps) => {
  return (
    <div
      style={{
        border: "1px dashed #9E9E9E",
        padding: 20,
        marginTop: 12,
        textAlign: "left",
        fontSize: "16px",
        lineHeight: "18px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const ButtonGroup = ({ style = {}, children = null }: ContentProps) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "35px",
      }}
    >
      {children}
    </div>
  );
};

ToolsContent.Heading = Heading;
ToolsContent.Body = Body;
ToolsContent.ButtonGroup = ButtonGroup;

export default ToolsContent;
